<template>
  <v-card class="elevation-12">
    <v-card-title>
      Авторизация
      <v-spacer></v-spacer>
      <v-icon color="primary">mdi-lock</v-icon>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field
          outlined
          label="Логин"
          name="username"
          v-model="form.login"
          type="text"
        ></v-text-field>

        <v-text-field
          outlined
          id="password"
          label="Пароль"
          name="password"
          v-model="form.password"
          type="password"
          hide-details
        ></v-text-field>
        <v-btn
          class="mt-5"
          block
          color="primary"
          id="sendButton"
          :loading="button_loader"
          :disabled="account.loading"
          @click.native="send">
          Войти
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        login: null,
        password: null,
      },
    };
  },
  computed: {
    account() {
      return this.$store.state.account.account;
    },
    button_loader() {
      return this.account.loading ? 'loading' : null;
    },
  },
  methods: {
    async send() {
      await this.$store.dispatch('account/fetchToken', this.form);

      this.$router.push('/');
    },
  },
};
</script>

<style scoped>

</style>
